import React, {Component} from 'react';
import axios from 'axios';

import auth0Client from '../../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import "react-toggle-component/styles.css"
import Toggle from "react-toggle-component"
import "react-toggle-component/styles.css"

import {SERVER_URL}  from '../../Constants';
import "react-datepicker/dist/react-datepicker.css";

const SCHEDULE_MONTHLY = 'MO';
const SCHEDULE_WEEKLY = 'W';
const SCHEDULE_DAILY = 'D';


class DispositionEditor extends Component {
    constructor(props) {
      super(props);

      console.log('disposition:' + props.disposition);
      this.state={
        disposition:props.disposition,
        name:props.disposition.name,
        description:props.disposition.description,
        scheduleActive:props.disposition.scheduleActive,
        scheduleFrequencyCd: (props.disposition) ? props.disposition.scheduleFrequencyCd : SCHEDULE_MONTHLY,
        venueId:'',
        emails:props.disposition.emails
      }
    }

  async componentDidMount() {
    //const { match: { params } } = this.props;
    var venue = auth0Client.getDefaultVenue();
    if (venue){
      this.setState({
        venueId:auth0Client.getDefaultVenue().id
  
      })     
      
    }else{
      ToastStore.error("An error occured: Login required.  Please log it");
    }
  
   
  }
  save=async()=>{
    console.log('Save disposition:' + this.state.disposition);
    if (!this.state.disposition){
      ToastStore.error('Invalid or missing filters'); return false;
    }

    if (!this.state.name){
      ToastStore.error('Invalid or missing Name'); return false;
    } 
    
    let statusItems = [];
    statusItems.push(this.state.selectedStatus);

    this.state.disposition.name = this.state.name;
    this.state.disposition.description = this.state.description;
    this.state.disposition.scheduleActive = this.state.scheduleActive;
    this.state.disposition.scheduleFrequencyCd = this.state.scheduleFrequencyCd;
    this.state.disposition.emails = this.state.emails;

    await axios.put(`${SERVER_URL}/Dispo/save`, {
      disposition : this.state.disposition

  }, {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId()
    
    }
  })
  .then((res)=>{

      this.setState({
      

      });
      if(res.status!==200){
        
         ToastStore.error("An error occured: " + res.response.data);
       }else{
          console.log(JSON.stringify(res.data));
         ToastStore.success('Disposition Settings Saved Successfully!');
         if (this.props.onSaveComplete){this.props.onSaveComplete(res.data)}
         if (this.props.onClose){
          
          this.props.onClose()
        };
       }
   
   
  })
  .catch ((e)=>{
      
      this.setState({
         
          error:e,

      })
      if (this.state.error && this.state.error.response){
        ToastStore.error(this.state.error.response.data);
      }
     
  })


  }
  handleInputChange=(event) =>{
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });
    }

render() {
  

  return (
    <div  className='container' style={{backgroundColor:'white'}}>
      <h5>Disposition Editor</h5>
      <small>Save the current filters &amp; scheduler</small>
      <br/>
      <div className='row' style={{width:'570px'}}>      
                <div className='col-4'>
                    <h6>Name:</h6> 
                 </div>
              
              <div className='col'>
                  <input
                            style={{Flex:1, backgroundColor:'white'}}
                            disabled={this.state.disabled}
                            type="text"
                            onChange={this.handleInputChange}
                            name="name"
                            className="form-control"
                            placeholder=""
                            value= {this.state.name}
                          />   
                          
             

              </div>
               
               
      </div>
      <br/>
      <div className='row'>      
                <div className='col-4'>
                  <h6>Description:</h6> 
                </div>   
              
              <div className='col'>
                  <input
                            style={{Flex:1, backgroundColor:'white'}}
                            disabled={this.state.disabled}
                            type="text"
                            onChange={this.handleInputChange}
                            name="description"
                            className="form-control"
                            placeholder=""
                            value= {this.state.description}
                          />   
                          

                </div>
               
      </div>
<hr/>
<br/>
    <h5>Scheduled Reports</h5>
    <small>Schedule this disposition report to run on a periodic basis</small>

      <br/><br/>
      <div className='row'>      
                <div className='col-4'>
                  <h6>Active:</h6> 
                </div>   
              
              <div className='col'>
              <Toggle id='expensive' labelRight="" checked={this.state.scheduleActive} onToggle={value => this.setState({scheduleActive:value})} /> 
                
                          

                </div>
               
      </div>

      <br/>
      <div className='row'>      
                <div className='col-4'>
                  <h6>Report Frequency:</h6> 
                </div>   
              
              <div className='col'>
              <select className='custom-select' style={{backgroundColor:'white'}}  value={this.state.scheduleFrequencyCd} onChange={this.handleInputChange} name='scheduleFrequencyCd'>
                 <option value={SCHEDULE_DAILY}>Daily</option>
                  <option value={SCHEDULE_WEEKLY}>Weekly (End of week)</option>
                  <option value={SCHEDULE_MONTHLY}>Monthly (End of month)</option>

              </select>
                                  

                </div>
               
      </div>
      <div className='row'>      
                <div className='col-4'>
                  <h6>Emails (',' seperated):</h6> 
                </div>   
              
              <div className='col'>
                  <input
                            style={{Flex:1, backgroundColor:'white'}}
                            disabled={this.state.disabled}
                            type="text"
                            onChange={this.handleInputChange}
                            name="emails"
                            className="form-control"
                            placeholder=""
                            value= {this.state.emails}
                          />   
                          

                </div>
               
      </div>

      <br/><br/>
      <div className="row">   
               
               <div className="col-md-12 text-center">
                <button
                        disabled={this.state.disabled}
                        className="btn btn-primary"
                        onClick={() => {this.save()}}>
                        Save
                      </button>
               </div>

       </div>
              <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>


    </div>
      )
  }

}  

export default DispositionEditor;
